import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { Props as BaseEntityLinkProps } from "shared/components/common/base-entity-link";

import {
  HeaderAllMenuItemLink,
  HeaderAllMenuItemLinkContainer,
  HeaderAllMenuTitle,
} from "scmp-app/components/header/header-oneline-menu-container/header-all-menu/common";
import type { headerAllMenuTopicsQuery$key } from "scmp-app/queries/__generated__/headerAllMenuTopicsQuery.graphql";

import { Container } from "./styles";

export type Props = {
  className?: string;
  queryParameter: BaseEntityLinkProps["query"];
  reference: headerAllMenuTopicsQuery$key;
};

export const HeaderAllMenuTopics: FunctionComponent<Props> = ({
  className,
  queryParameter,
  reference,
}) => {
  const queue = useFragment(
    graphql`
      fragment headerAllMenuTopicsQuery on Query {
        topicQueue: queue(filter: { name: $topicQueueName }) {
          items(first: 6) {
            edges {
              node {
                ... on Topic {
                  ...entityLink
                  name
                }
              }
            }
          }
        }
      }
    `,
    reference,
  );

  return (
    <Container className={className}>
      <HeaderAllMenuTitle>Topics</HeaderAllMenuTitle>
      <HeaderAllMenuItemLinkContainer>
        {queue.topicQueue?.items?.edges.map((edge, index) => (
          <HeaderAllMenuItemLink key={index} query={queryParameter} reference={edge.node}>
            {edge.node.name}
          </HeaderAllMenuItemLink>
        ))}
      </HeaderAllMenuItemLinkContainer>
    </Container>
  );
};

HeaderAllMenuTopics.displayName = "HeaderAllMenuTopics";
